module.exports = __webpack_public_path__ + "assets/barometro.7930f9933c86173e2a521b7c340b26c2.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/barometro.png
// module id = 878
// module chunks = 0